<template>
  <v-dialog v-model="dialog" :max-width="width > 480 ? 460 : 340" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title>
        <span class="headline">Suche</span>
        <HelpModal v-if="$vuetify.breakpoint.xsOnly"/>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-text-field
                v-model="query"
                label="Suchbegriff"
                prepend-icon="search"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-icon>mdi-information-outline</v-icon>
            </v-col>
            <v-col cols="11">
              Verwenden Sie Anführungszeichen um nach Phrasen zu suchen und die folgenden Formularfelder zur Eingrenzung der Suchergebnisse.
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-menu
                ref="from"
                v-model="from"
                :close-on-content-click="false"
                :return-value.sync="dateFrom"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFromFormatted"
                    label="von"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateFrom"
                               :max="dateTo || new Date().toISOString().substr(0, 10)"
                               min="2008-01-01"
                               show-week
                               no-title
                               scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="from = false">Abbrechen</v-btn>
                  <v-btn text color="primary" @click="$refs.from.save(dateFrom)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-menu
                ref="to"
                v-model="to"
                :close-on-content-click="false"
                :return-value.sync="dateTo"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateToFormatted"
                    label="bis"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateTo"
                               :max="new Date().toISOString().substr(0, 10)"
                               :min="dateFrom"
                               show-week
                               no-title
                               scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="to = false">Abbrechen</v-btn>
                  <v-btn text color="primary" @click="$refs.to.save(dateTo)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12">
              <v-autocomplete
                v-model="selectedServices"
                :items="services"
                prepend-icon="folder"
                label="Dienste"
                multiple
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12">
               <v-checkbox v-model="pdfs" label="PDF-Dateien durchsuchen"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Abbrechen</v-btn>
        <v-btn color="blue darken-1" text @click="dialog = false; resetSearch()">Löschen</v-btn>
        <v-btn color="blue darken-1" text @click="dialog = false; triggerSearch()">Suchen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import HelpModal from '@/components/HelpModal.vue';
  export default {
    data() {
      return {
        interval: {},
        from: false,
        to: false,
        maxTo: new Date().toISOString().substr(0, 10),
        // selectedServices: [],
      };
    },
    methods: {
      resetSearch() {
        this.dateFrom = null;
        this.dateTo = null;
        this.selectedServices = [];
        this.$store.commit('updateSearchparameters', {key: 'query', val: ''});
        this.$store.commit('updateSearchparameters', {key: 'pdfs', val: true});
        this.$store.commit('updateSearchparameters', {key: 'searchString', val: ''});
        if (this.$route.name !== 'home') {
          this.$router.push('/home');
        }
      },
      triggerSearch() {
        this.$store.dispatch('performSearch', 'searchmodal->trigger');
      },
      formatDate(date) {
        if (!date) {
          return null;
        }
        const [year, month, day] = date.split('-');
        return `${day}.${month}.${year}`;
      },
      parseDate(date) {
        if (!date) {
          return null;
        }
        const [day, month, year] = date.split('.');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      },
    },
    computed: {
      services() {
          return this.$store.state.list.services;
      },
      width() {
        return window.innerWidth;
      },
      query: {
        get() {
          return this.$store.state.list.filters.query;
        },
        set(val) {
          this.$store.commit('updateSearchparameters', {key: 'query', val});
        },
      },
      dateFromFormatted() {
        return this.formatDate(this.dateFrom);
      },
      dateFrom: {
        get() {
          return this.$store.state.list.filters.from;
        },
        set(val) {
          this.$store.commit('updateSearchparameters', {key: 'from', val});
        },
      },
      dateToFormatted() {
        return this.formatDate(this.dateTo);
      },
      dateTo: {
        get() {
          return this.$store.state.list.filters.to;
        },
        set(val) {
          this.$store.commit('updateSearchparameters', {key: 'to', val});
        },
      },
      pdfs: {
        get() {
          return this.$store.state.list.filters.pdfs;
        },
        set(val) {
          this.$store.commit('updateSearchparameters', {key: 'pdfs', val});
        },
      },
      selectedServices: {
        get() {
          return this.$store.state.list.filters.services;
        },
        set(val) {
          this.$store.commit('updateSearchparameters', {key: 'services', val});
        },
      },
      dialog: {
        get() {
          return this.$store.state.app.showSearchModal;
        },
        set(val) {
          this.$store.commit('toggleSearchModal', val);
        },
      },
      value() {
        return this.$store.state.list.currentProgress;
      },
    },
    components: {
      HelpModal,
    },
  };
</script>

<style lang="less">
  @media screen and (max-width: 599px) {
    .v-text-field {
      padding-top: 0;
    }
  }
</style>
